import { render, staticRenderFns } from "./LmDocumentWorkflow.vue?vue&type=template&id=701b27b8&scoped=true"
import script from "./LmDocumentWorkflow.vue?vue&type=script&lang=js"
export * from "./LmDocumentWorkflow.vue?vue&type=script&lang=js"
import style0 from "./LmDocumentWorkflow.vue?vue&type=style&index=0&id=701b27b8&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "701b27b8",
  null
  
)

export default component.exports